import React from "react";
import { createRoot } from "react-dom/client";
import App, { VERSION } from "./App.jsx";

// طباعة رقم الإصدار في وحدة التحكم لتسهيل التتبّع
// eslint-disable-next-line no-console
console.info(`نظام إدارة المنظومة العدلية — v${VERSION}`);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
